var _style, _g, _g2, _rect, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountDookuLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0cdl{fill:#791616;}\r\n\t.st1cdl{fill:#FAC8AA;}\r\n\t.st2cdl{fill:#F9C2A0;}\r\n\t.st3cdl{fill:#DBDBDB;}\r\n\t.st4cdl{fill:#BAB9B9;}\r\n\t.st5cdl{fill:#825716;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0cdl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2_1_"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 77.8,
    className: "st1cdl",
    width: 11,
    height: 154.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1cdl",
    d: "M92.5,67c-10.1,22.6-20.2,45.3-30.3,67.9c-1.8,6.5-6.8,27,4.3,39.7c0.8,0.9,1.8,1.9,2.8,2.7 c2.5,0.7,5,1.3,7.5,2c6.6,12.1,13.2,21.4,18.2,27.8c11.8,15.1,22.5,28.5,40.7,34.9c5.4,1.9,10.1,2.7,13.1,3.1 c0-60.1,0-120.3,0-180.4C130.1,65.5,111.3,66.2,92.5,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2cdl",
    d: "M234.8,134.1c-11.7-23.8-23.3-47.6-35-71.4c-17,0.7-33.9,1.4-50.9,2v180.4c2.6-0.1,6.5-0.5,11-1.6 c18.5-4.8,29.8-18.3,41.4-32.5c5.6-6.9,12.9-17,19.8-30.2c3.5-0.5,6.1-1.8,7.9-3.1C238.8,170.8,241,153.4,234.8,134.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3cdl",
    d: "M79.8,135.2C90.9,156,102,176.9,113,197.8c3.2,0,6.3,0,9.5,0c4.4-1.9,14-5.6,27-5.7 c13.4-0.1,23.2,3.7,27.6,5.7c2.5,0,5,0,7.5,0c11.6-20.6,23.1-41.2,34.7-61.8c2.8,21,5.7,42,8.5,63c-6.6,10.6-13.3,21.1-19.9,31.7 c-9.7,8.5-19.3,17.1-29,25.6c-19.5-0.3-38.9-0.5-58.4-0.8c-10.4-9-20.9-18.1-31.3-27.1c-6.5-10.4-13-20.9-19.5-31.3 C73.2,176.4,76.5,155.8,79.8,135.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cdl",
    d: "M113,208c0.8-16.7,16.5-30.1,35.3-30.5c19.5-0.5,36.5,13.1,37.3,30.5c4.4-6.3,8.9-12.7,13.3-19 c-11.3-13.7-22.6-27.4-33.9-41.1c-10.3,0-20.7,0-31,0c-11.8,13-23.5,26.1-35.3,39.1C103.5,194,108.3,201,113,208z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5cdl",
    d: "M67.7,184.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cdl",
    d: "M59.9,136.7c7.5,5.1,15.1,10.3,22.6,15.4c0.1-15.7,0.2-31.4,0.2-47.1c4.7-12.8,9.4-25.6,14.2-38.3 c7,4.7,26.5,16.7,54.1,16.5c25.2-0.2,43.3-10.5,50.5-15.1c5.2,12.2,10.4,24.5,15.6,36.7c0.2,15.6,0.3,31.2,0.5,46.8 c7.5-4.9,15.1-9.8,22.6-14.7c4.6-62.5-45.2-112-96.4-108.5C96.6,31.6,55.3,79.4,59.9,136.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountDookuLogo);
export default __webpack_public_path__ + "static/media/count-dooku-logo.57389e66.svg";
export { ForwardRef as ReactComponent };